// Lib
import React from 'react';
import classNames from 'classnames';
import { stopDefaultAndPropagation } from '../../../../utils/domUtil';
import PopupTrigger from '../../../popupPanel/PopupTrigger';
import EmojiImage from '../../../emoji/EmojiImage';
import CalloutEmojiPopup from './CalloutEmojiPopup';
import { CalloutNodeViewIconProps } from './calloutNodeViewTypes';

const DesktopCalloutNodeViewIcon: React.FC<CalloutNodeViewIconProps> = (props) => {
    const { node, updateAttributes, popupId } = props;

    return (
        <div className="DesktopCalloutNodeViewIcon CalloutNodeViewIcon" onClick={stopDefaultAndPropagation}>
            <PopupTrigger className="trigger" popupId={popupId}>
                {(isPopupOpen) => (
                    <div className={classNames('callout-icon-wrapper', { active: isPopupOpen })}>
                        <EmojiImage emojiCode={node.attrs.iconCode} size={18} />
                    </div>
                )}
            </PopupTrigger>
            <CalloutEmojiPopup
                popupId={popupId}
                selectedEmojiId={node.attrs.iconCode}
                updateAttributes={updateAttributes}
            />
        </div>
    );
};

export default DesktopCalloutNodeViewIcon;
